import { CircularProgress, Stack, Typography } from '@mui/material';
import { styles } from './LoadingSubmission.style';
import { useContext } from 'react';
import { LocalizationContext } from 'src/Context/LocalizationContext';

interface ILoadingProps {}

export default function LoadingSubmissionComponent(props: ILoadingProps) {
	const { SubmissionInProgress } = useContext(LocalizationContext);
	const { SubmittingQuestionnaireHeader: header } = SubmissionInProgress;

	return (
		<Stack direction={'column'} spacing={3} alignItems={'center'} justifyContent={'center'} height={'50vh'}>
			<CircularProgress />
			<Typography variant="h3" sx={styles.header}>
				{header
					? header.replaceAll(`\\n`, `\n`)
					: 'Your documents are being submitted.\nThis may take a minute...'}
			</Typography>
		</Stack>
	);
}
